import React from 'react'
import { Link, useParams } from 'react-router-dom'

import Navbar from '../../components/navbar/navbar'
import DetailSidebar from '../../components/detail-sidebar'
import PropertyDetail from '../../components/property-detail'
import Footer from '../../components/footer'
import FooterTop from '../../components/footer-top'
import SEO from '../../components/SEO'
import ExchangeRateDisclosure from '../../components/ExchangeRateDisclosure'

import { propertyData } from '../../data/data'

export default function SinglePropertyThree() {
    let params = useParams()
    let id:any = params.id
    let data = propertyData.find((item:any)=>item.id === parseInt(id))

    // SEO dinámico basado en la propiedad
    const propertyName = data?.name || 'Propiedad en Venta';
    const propertyPrice = data?.value || '$7,600';
    const propertyLocation = data?.loction || 'Riviera Nayarit';
    const propertyImage = Array.isArray(data?.image) ? data?.image[0] : data?.image || 'https://ampirivieranayarit.com/wp-content/uploads/2025/03/mob-slide-1.jpg';

    // Schema.org para RealEstateListing
    const propertySchema = {
      "@context": "https://schema.org",
      "@type": "RealEstateListing",
      "name": propertyName,
      "description": `${propertyName} - Propiedad disponible en ${propertyLocation}`,
      "url": `https://ampirivieranayarit.com/modulob/single-property-3/${id || ''}`,
      "image": propertyImage,
      "price": propertyPrice,
      "priceCurrency": "MXN",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": propertyLocation,
        "addressCountry": "MX"
      },
      "offers": {
        "@type": "Offer",
        "price": propertyPrice,
        "priceCurrency": "MXN",
        "availability": "https://schema.org/InStock"
      }
    };

  return (
    <>
     <SEO
       title={propertyName}
       description={`${propertyName} en venta en ${propertyLocation}. Encuentra esta y más propiedades exclusivas verificadas por AMPI Riviera Nayarit.`}
       path={`/modulob/single-property-3/${id || ''}`}
       image={propertyImage}
       type="article"
       schema={propertySchema}
     />
     <Navbar transparent={false}/>   

    <section className="bg-title">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-11 col-md-12">
            
                    <div className="property_block_wrap style-4">
                        <div className="prt-detail-title-desc">
                            <span className="label text-light bg-warning mb-1 d-inline-flex">For Sale</span>
                            <h3 className="text-light mt-3">{data?.name ? data?.name : 'Jannat Graynight Mood In Siver Colony, London'}</h3>
                            <span><i className="lni-map-marker"></i> 778 Country St. Panama City, FL</span>
                            <h3 className="prt-price-fix text-light mt-2">$7,600<sub>/month</sub></h3>

                            {/* Disclaimer de tipo de cambio */}
                            <div className="alert alert-warning mt-3 mb-3" role="alert">
                                <div className="d-flex align-items-start">
                                    <i className="fa-solid fa-exclamation-triangle me-2 mt-1"></i>
                                    <div>
                                        <strong>Nota importante sobre tipo de cambio:</strong>
                                        <p className="mb-2 mt-1">El tipo de cambio mostrado es referencial. Cada agencia inmobiliaria maneja su propio tipo de cambio según sus políticas comerciales.</p>
                                        <ExchangeRateDisclosure variant="badge" className="mb-2" />
                                        <p className="mb-0 small">Por favor confirma el precio final directamente con la agencia o asesor responsable de esta propiedad.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="pbwts-social">
                                <ul className='mt-2'>
                                    <li>Share:</li>
                                    <li><Link to="#"><i className="fa-brands fa-facebook"></i></Link></li>
                                    <li><Link to="#"><i className="fa-brands fa-linkedin"></i></Link></li>
                                    <li><Link to="#"><i className="fa-brands fa-twitter"></i></Link></li>
                                    <li><Link to="#"><i className="fa-brands fa-instagram"></i></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                </div>	
            </div>
        </div>
    </section>

    <section className="gray-simple">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12">
                    <PropertyDetail/>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                    <DetailSidebar/>
                </div>
            </div>
        </div>
    </section>
    <FooterTop bg="theme-bg"/>
    <Footer/>
    </>
  )
}
